import api from './api';
import type { Dirigente } from '../types/dirigente.types';

export const dirigenteService = {
  // Criar novo dirigente
  criar: async (dirigente: Dirigente): Promise<Dirigente> => {
    const { data } = await api.post('/dirigentes', dirigente);
    return data;
  },

  // Listar dirigentes de uma instituição
  listar: async (instituicaoId: string, apenasAtivos: boolean = false): Promise<Dirigente[]> => {
    const { data } = await api.get(`/dirigentes/instituicao/${instituicaoId}`, {
      params: { apenasAtivos }
    });
    return data;
  },

  // Buscar dirigente por ID
  buscarPorId: async (id: string): Promise<Dirigente> => {
    const { data } = await api.get(`/dirigentes/${id}`);
    return data;
  },

  // Buscar dirigente por CPF
  buscarPorCpf: async (cpf: string): Promise<Dirigente | null> => {
    try {
      const cleaned = (cpf || '').replace(/\D/g, '');
      const { data } = await api.get(`/dirigentes/cpf/${encodeURIComponent(cleaned)}`);
      return data;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  },

  // Alias para buscarPorId (compatibilidade)
  obter: async (id: string): Promise<Dirigente> => {
    console.log('[dirigenteService] obter() chamado com ID:', id);
    const { data } = await api.get(`/dirigentes/${id}`);
    console.log('[dirigenteService] obter() retornou:', data);
    return data;
  },

  // Atualizar dirigente
  atualizar: async (id: string, dirigente: Dirigente): Promise<Dirigente> => {
    const { data } = await api.put(`/dirigentes/${id}`, dirigente);
    return data;
  },

  // Inativar dirigente
  inativar: async (id: string, dataTermino: string, motivo: string): Promise<void> => {
    await api.post(`/dirigentes/${id}/inativar`, {
      dataTermino,
      motivo
    });
  },

  // Inativar apenas o vínculo (cargo) do dirigente NA instituição informada,
  // sem afetar vínculos da mesma pessoa em outras instituições.
  inativarVinculo: async (
    id: string,
    params: { instituicaoId: string; cargo?: string; dataTermino: string; motivo: string }
  ): Promise<void> => {
    await api.post(`/dirigentes/${id}/vinculo/inativar`, params);
  },

  // Move dirigente to the end of the queue (Convênios ordering) - best-effort
  moveToEndQueue: async (id: string): Promise<void> => {
    try {
      await api.post(`/dirigentes/${encodeURIComponent(id)}/fila/move-to-end`);
    } catch (err) {
      console.warn('[dirigenteService] moveToEndQueue failed (endpoint may not exist):', err);
      throw err;
    }
  },

  // Fetch queue for President/Treasurer cargos
  getQueue: async (): Promise<Dirigente[]> => {
    const { data } = await api.get('/dirigentes/queue');
    return data;
  },

  // Verificar avisos de cargos obrigatórios
  verificarAvisos: async (instituicaoId: string): Promise<{ avisos: string[]; temAvisos: boolean }> => {
    const { data } = await api.get(`/dirigentes/instituicao/${instituicaoId}/avisos`);
    return data;
  },

  // Criar vínculo para um dirigente existente
  criarVinculo: async (dirigenteId: string, payload: { instituicaoId: string; cargo: string; dataInicioCargo?: string; statusCargo?: string }) => {
    const { data } = await api.post(`/dirigentes/${encodeURIComponent(dirigenteId)}/vinculo`, payload);
    return data;
  }
};

export default dirigenteService;

